module.exports = __webpack_public_path__ + "img/topics3.626e5940.png";